import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "min-h-screen flex flex-col justify-between" }
const _hoisted_2 = { class: "flex flex-col flex-1 items-center justify-center -mt-36" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-md p-5 w-11/12 md:w-8/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12" }
const _hoisted_4 = { class: "w-full flex flex-col my-4 text-center" }
const _hoisted_5 = { class: "text-lg md:text-2xl" }
const _hoisted_6 = { class: "text-lg md:text-2xl" }
const _hoisted_7 = { class: "w-full flex flex-col my-4 items-center mt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex justify-center items-center" }, [
          _createElementVNode("a", {
            class: "text-center",
            href: "/"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "p-2.5 w-24 h-auto"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('global.atencion')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('errors.pagina.no.encontrada')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.volver && $options.volver(...args))),
            class: "w-full md:w-7/12 lg:w-8/12 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
          }, " VOLVER ")
        ])
      ])
    ])
  ]))
}